import { FC, useCallback, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { Routes } from '@/_shared/constants/routes';
import { VideoPlayer } from '../components/VideoPlayer';

type LocationState = {
  videoSrc: string;
  startFrom?: number;
};

export const VideoScreen: FC = () => {
  const { videoId } = useParams<{ videoId: string }>();
  const location = useLocation();
  const navigate = useNavigate();
  const state = location.state as LocationState | undefined;

  const onVideoClose = useCallback(() => {
    navigate(-1);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [navigate]);

  // If no state is provided, redirect back to training
  useEffect(() => {
    if (!state?.videoSrc) {
      navigate(Routes.TrainingHardSkills, { replace: true });
    }
  }, [navigate, state?.videoSrc]);

  if (!state?.videoSrc || !videoId) {
    return null;
  }

  return (
    <>
      <VideoPlayer
        id={videoId}
        src={state.videoSrc}
        open
        startFrom={state.startFrom}
        onClose={onVideoClose}
      />
      <ToastContainer style={{ zIndex: 99999999 }} />
    </>
  );
};
